import React from 'react';
import './SectionHeading.css';

export const SectionHeading = ({
  align = "center",
  title,
  description,
  badge,
  className = "",
}) => {
  const alignClass = {
    center: "items-center text-center",
    left: "items-start text-left",
    right: "items-end text-right",
  };

  return (
    <div className={`section-heading ${alignClass[align]} ${className}`}>
      {badge && <span className="section-badge">{badge}</span>}
      <h3>{title}</h3>
      {description && <p className="section-lead">{description}</p>}
    </div>
  );
};
